import React from 'react';
import HotSeatLoading from '../hotseat/HotSeatLoading';
import stageImage from '../../assets/virtual-raffle/loading-stage.webp';

export default function RaffleLoading({ ready = false }) {
  return <HotSeatLoading ready={ready} image={stageImage} label="SORTEO VIRTUAL" description="Preparando el ánfora y el escenario" />;
}
